import * as referRequestActionConstants from '../constants/referRequestActionConstants';

const initialState = {
  appliedUser: {},
  loading: false,
};

const referRequestReducer = (state = initialState, action) => {
  switch (action.type) {
    case referRequestActionConstants.APPLICATION_REQUEST:
      return {
        ...state,
        appliedUser: {},
        loading: true,
      };
    case referRequestActionConstants.APPLICATION_REQUEST_SUCCESS:
      return {
        ...state,
        appliedUser: action.payload,
        loading: false,
      };
    case referRequestActionConstants.APPLICATION_REQUEST_FAILURE:
      return {
        ...state,
        loading: false,
      };

    default:
      return state;
  }
};

export default referRequestReducer;
